import WithRender from "../../templates/base/factsheet.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getFactsheet"]),
    name: () => {
      return "Factsheet";
    }
  }
});
